<template>
  <tracking />
</template>

<script>
import tracking from "@/components/3pl/Settings/Tracking/index";
export default {
  components: {
    tracking,
  },
};
</script>

<style></style>
